import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import { NotFound } from '../NotFound';
import { DashboardPage } from './DashboardPage';
import { Helmet } from 'react-helmet-async';
import { DashboardProvider } from '../../../contexts/states/DashboardState';
import '../../../styles/dashboard.css';
import { DesktopHeader } from '../../Layouts/dashboard layouts/DesktopHeader';
import { SideNav } from '../../Layouts/dashboard layouts/SideNav';
import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../../../contexts/states/GlobalState';
import { GlobalErrorHandler } from '../../Layouts/GlobalErrorHandler';
import { MobileHeader } from '../../Layouts/dashboard layouts/MobileHeader';
import { SideBar } from '../../Layouts/dashboard layouts/SideBar';
import { UsersPage } from './UsersPage';
import { DriversPage } from './DriversPage';
import { FeedbacksPage } from './FeedbacksPage';
import { SettingsPage } from './SettingsPage';
import { RidesPage } from './RidesPage';

export const DashboardRoutes = () => {
  const { getAdmin, admin, authError, globalError } = useContext(GlobalContext);
  const [title, setTitle] = useState('overall');
  const newTitle = (title) => {
    setTitle(title);
  };

  useEffect(() => {
    getAdmin();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (authError) {
      setTimeout(() => {
        window.location.reload();
      }, 5000);
    }
  }, [authError]);

  const closeMobileMenu = () => {
    const menu = document.querySelector('.dash-mobile-menu-con');
    const backgroundOverlay = document.querySelector('.background-overlay');
    const modalContainer = document.querySelector('.info-modal-container');
    modalContainer?.classList.remove('active');
    menu.classList.remove('active');
    backgroundOverlay.classList.remove('active');
  };

  return (
    <DashboardProvider>
      <Router>
        <Helmet>
          <title>
            {admin.username ? admin.username : 'loading...'}'s Dashboard |
            LionTaxi Admin
          </title>
        </Helmet>
        <div className='dashboard-container'>
          <div className='dashboard-header-con desktop'>
            <div></div>
            <DesktopHeader />
          </div>
          <div className='dashboard-header mobile'>
            <MobileHeader title={title} />
          </div>
          <div className='dashboard-con'>
            <div className='sidenav-con'>
              <SideNav closeMobileMenu={closeMobileMenu} newTitle={newTitle} />
            </div>
            <div>
              <Switch>
                {authError && <Redirect push to='/admin' />}
                <Route
                  exact
                  path='/admin/dashboard'
                  component={DashboardPage}
                />
                <Route
                  exact
                  path='/admin/dashboard/users'
                  component={UsersPage}
                />
                <Route
                  exact
                  path='/admin/dashboard/drivers'
                  component={DriversPage}
                />
                <Route
                  exact
                  path='/admin/dashboard/rides'
                  component={RidesPage}
                />
                <Route
                  exact
                  path='/admin/dashboard/feedbacks'
                  component={FeedbacksPage}
                />
                <Route
                  exact
                  path='/admin/dashboard/settings'
                  component={SettingsPage}
                />
                <Route component={NotFound} />
              </Switch>
            </div>
            <div className='log-info-con'>
              <SideBar />
              <footer className='mobile-footer mobile-620'>
                <span>
                  &#169; LionTaxi 2021-present. Built with{' '}
                  <i className='fas fa-heart'></i> by{' '}
                  <a href='https://twitter.com/elijahtrillionz'>
                    Elijah Trillionz
                  </a>
                </span>
              </footer>
            </div>
          </div>
          <div className='connection-error-handler'>
            <div className={`modal-con ${globalError && 'active'}`}>
              {globalError && (
                <GlobalErrorHandler
                  error={`${globalError}! ${
                    authError ? 'Redirecting you to login page in 5 secs' : ''
                  }`}
                  context={GlobalContext}
                />
              )}
            </div>
          </div>
          <div className='background-overlay' onClick={closeMobileMenu}></div>
        </div>
      </Router>
    </DashboardProvider>
  );
};
